import AUTRE_ICO from "../assets/images/icone-sis/autre.png"
import DOC_CARTOGRAPHIQUE_ICO from "../assets/images/icone-sis/doc-cartographique.png"
import DOC_TYPE_ICO from "../assets/images/icone-sis/documents-types.png"
import FORUM_ICO from "../assets/images/icone-sis/forum.png"
import MANUEL_GUIDE_ICO from "../assets/images/icone-sis/manuel-et-guides.png"
import OUTIL_CALCUL_ICO from "../assets/images/icone-sis/outils-de-calculs.png"
import RAPPORT_ICO from "../assets/images/icone-sis/rapports.png"
import RESSOURCE_ICO from "../assets/images/icone-sis/ressources.png"

const iconList={"DOC_CARTOGRAPHIQUE_ICO":DOC_CARTOGRAPHIQUE_ICO,"DOC_TYPE_ICO":DOC_TYPE_ICO,"FORUM_ICO":FORUM_ICO,"MANUEL_GUIDE_ICO":MANUEL_GUIDE_ICO,
"OUTIL_CALCUL_ICO":OUTIL_CALCUL_ICO,"RAPPORT_ICO":RAPPORT_ICO,"RESSOURCE_ICO":RESSOURCE_ICO,"AUTRE_ICO":AUTRE_ICO
}



export default iconList